import { TabsProps } from 'antd'
import { RouterPages } from 'shared/model/routes'

export const clientDetailTabs: TabsProps['items'] = [
  {
    label: 'Общие данные',
    key: RouterPages.generalInfo,
  },
  {
    label: 'История заказов',
    key: RouterPages.orderHsitory,
  },
  {
    label: 'Начисление/списание баллов',
    key: RouterPages.bonusHistory,
  },
  {
    label: 'Сохраненные адреса',
    key: RouterPages.savedAddresses,
  },
]
